<template>
  <div class="chart-container">
    <ApexChart
      ref="dailyLine"
      height="250"
      type="area"
      :options="options"
      :series="series"
    ></ApexChart>
  </div>
</template>

<script>
import ApexChart from "vue-apexcharts";

export default {
  components: {
    ApexChart,
  },
  props: {
    chartdata: Object,
  },
  computed: {
    series() {
      return [
        {
          name: "Total",
          data: this.chartdata.datasets[0],
        },
      ];
    },
  },
  data() {
    return {
      options: {
        colors: ["#07C07E"],
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 0.0,
            opacityFrom: 0.4,
            opacityTo: 0.05,
            stops: [0, 100],
          },
        },

        stroke: {
          colors: ["#07C07E"],
          curve: "straight",
          width: 2,
        },
        width: "100%",
        tooltips: {
          xaxis: {},
        },
        grid: {
          borderColor: "#DEDEF1",
          strokeDashArray: 9,
          borderWidth: "1px",
        },
        xaxis: {
          axisBorder: {
            show: false,
          },
          // type: "datetime",
          categories: this.chartdata.labels,
          labels: {
            // format: "yyyy MMM",
            minHeight: 76,
            rotate: 0,
            hideOverlappingLabels: true,
            style: {
              colors: "#797997",
              fontSize: "12px",
              lineHeight: "16px",
              fontWeight: "700",
            },
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          labels: {
            style: {
              colors: "#797997",
              fontSize: "12px",
              lineHeight: "16px",
              fontWeight: "700",
            },
          },
          tickAmount: 5,
        },
        chart: {
          width: "100%",
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
        },
        legend: {
          itemMargin: {
            vertical: 20,
          },
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.chart-container::v-deep {
  .apexcharts-canvas {
    margin-top: -24px;
    margin-bottom: 12px;
  }
  .apexcharts-legend {
    justify-content: space-between !important;

    .apexcharts-legend-series {
      margin-left: 4px !important;
      margin-right: 4px !important;
    }
  }
}
</style>
